



















import Component, { mixins } from 'vue-class-component'
import { Getter } from 'vuex-class'
import submenuMixin from '@/modules/app/components/sidebar/submenuMixin'

@Component
export default class StockSubmenu extends mixins(submenuMixin) {
  pageGroup = 'stock'

  @Getter('hasPermission', { namespace: 'auth' }) hasPermission!: (permission: string) => boolean
}
